export default () => import(/* webpackChunkName: 'coffee/app/delivery/received' */ './Received');
